/**
 * `text` with its first case-insensitive match of `query` marked, as the design highlights the
 * typed word in every row. Plain text, never HTML: a record name cannot inject markup.
 */
export function HighlightMatch({ text, query }: { text: string; query: string }) {
  const needle = query.trim().toLowerCase();
  const start = needle ? text.toLowerCase().indexOf(needle) : -1;
  if (start < 0) return text;

  const end = start + needle.length;
  return (
    <>
      {text.slice(0, start)}
      <mark className="rounded-sm bg-success-subtle font-semibold text-foreground">
        {text.slice(start, end)}
      </mark>
      {text.slice(end)}
    </>
  );
}
